import React, { useEffect, useRef } from 'react';
import { useAnimation } from '../hooks/useAnimation';

const RoundResultsScreen = ({ data }) => {
  const { animateNumbers, createConfetti } = useAnimation();
  const statValueRefs = useRef({});

  useEffect(() => {
    if (!data) return;

    // Sort choices by statistic value
    const sortedChoices = Object.entries(data.choices).sort((a, b) => {
      const valueA = a[1].stats ? a[1].stats[data.statistic] : a[1][data.statistic];
      const valueB = b[1].stats ? b[1].stats[data.statistic] : b[1][data.statistic];
      return valueB - valueA;
    });

    // Animate results appearance with dramatic timing
    sortedChoices.forEach(([playerId, choice], index) => {
      setTimeout(() => {
        const resultElement = document.querySelector(`[data-player="${playerId}"]`);
        if (resultElement) {
          resultElement.classList.add('animate-in');
          
          // Animate the number counting up
          setTimeout(() => {
            const statValue = choice.stats ? choice.stats[data.statistic] : choice[data.statistic];
            const numberElement = statValueRefs.current[playerId];
            if (numberElement) {
              animateNumbers(numberElement, statValue, 1000);
            }
          }, 300);

          // Special winner animation
          if (playerId === data.winner) {
            setTimeout(() => {
              resultElement.classList.add('animate-winner');
              createConfetti();
            }, 1500);
          }
        }
      }, index * 500);
    });
  }, [data, animateNumbers, createConfetti]);

  if (!data) return null;

  // Sort choices by statistic value
  const sortedChoices = Object.entries(data.choices).sort((a, b) => {
    const valueA = a[1].stats ? a[1].stats[data.statistic] : a[1][data.statistic];
    const valueB = b[1].stats ? b[1].stats[data.statistic] : b[1][data.statistic];
    return valueB - valueA;
  });

  return (
    <div className="screen active">
      <div className="card">
        <h2>Round Results</h2>
        <div className="round-results">
          <h3>Competing Statistic: {data.statistic}</h3>
          {sortedChoices.map(([playerId, choice]) => {
            const isWinner = playerId === data.winner;
            
            return (
              <div
                key={playerId}
                className={`result-item ${isWinner ? 'winner' : ''}`}
                data-player={playerId}
              >
                <span className="player-name">{playerId}</span>
                <span>{choice.name}</span>
                <span ref={el => statValueRefs.current[playerId] = el} className="stat-value">
                  0
                </span>
                {isWinner && <span>🏆</span>}
              </div>
            );
          })}
        </div>
        <div className="scores">
          <h3>Current Scores</h3>
          {data.scores
            .sort((a, b) => b.score - a.score)
            .map((score) => {
              const isLeader = score.score === Math.max(...data.scores.map(s => s.score));
              return (
                <div key={score.id} className={`score-item ${isLeader ? 'current-leader' : ''}`}>
                  <span>{score.id}</span>
                  <span>{score.score} wins</span>
                </div>
              );
            })}
        </div>
        <div>
          <p>Next round starts in 3 seconds...</p>
        </div>
      </div>
    </div>
  );
};

export default RoundResultsScreen;